query MobileSdkFilterOptions($limit: Int = 1000) {
	msdk_test_runs(limit: $limit) {
		app_group_uniq_array
		app_version_group_uniq_array
		sdk_type_group_uniq_array
		product_version_group_uniq_array
	}
}
